import io from "socket.io-client";
import { decodeToken } from "react-jwt";

// Get Admin ID from token in localStorage
const getAdminId = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decoded = decodeToken(token);
      if (decoded && (decoded.id || (decoded.response && decoded.response._id))) {
        return decoded.id || decoded.response._id;
      }
    } catch (e) {
      console.error("Error decoding admin token:", e);
    }
  }
  return "";
};

const API_URL = process.env.REACT_APP_API_URL || "https://api.drotly.co.uk";

// Create socket instance
const socket = io(API_URL, {
  transports: ["websocket"],
  auth: (cb) => cb({ token: localStorage.getItem("token") || "" }),
});

// Join admin room on connection (the API only allows the room of the token's owner)
socket.on("connect", () => {
  const adminId = getAdminId();
  if (adminId) {
    socket.emit("join_room", { user_id: adminId, token: localStorage.getItem("token") });
    console.log("Admin connected and joined room:", adminId);
  }
});

export default socket;
